<div 
    cdkDrag 
    #dragRef="cdkDrag"
    class="popup-wrapper" 
    [class.minimized]="entry.minimized" 
    [style.width.px]="entry.size.width"
    [style.height.px]="entry.size.height"
    [style.left.px]="entry.position.x"
    [style.top.px]="entry.position.y"
    [style.zIndex]="entry.zIndex"
    (cdkDragEnded)="onDragEnd($event)"
    (mousedown)="onFocusOnce($event)"
    >

    <div class="popup-titlebar" cdkDragHandle>
        <span class="popup-title">{{ entry.title }}</span>
        <div class="popup-actions">
            <button class="popup-btn" (click)="toggleMinimize(); $event.stopPropagation()" [title]="entry.minimized ? 'Restore': 'Minimize'">
                <!-- <span>{{ entry.minimized ? '^' : '-'}}</span> -->
                <span *ngIf="!entry.minimized"><i class="pi pi-minus"></i></span>
                <span *ngIf="entry.minimized"><i class="pi pi-window-maximize"></i></span>
            </button>
            <button class="popup-btn close-btn" (click)="close(); $event.stopPropagation()" title="Close">
                <span><i class="pi pi-times"></i></span>
            </button>
        </div>
    </div>

    <div class="popup-content" (mousedown)="$event.stopPropagation()" [hidden]="entry.minimized">
        <!-- <router-outlet [name]="entry.id"></router-outlet> -->
         <!-- @if(entry.url) {
            <iframe [src]="safeIframeUrl" frameborder="0"
         style="width: 100%;height: 100%;border: none;"></iframe>
         } -->
         <ng-container #contentSlot></ng-container>
    </div>
</div>